import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useProjects } from '../lib/projects';
import { usePersistedState } from '../lib/usePersistedState';
import { PhotosPanel } from '../components/PhotosPanel';

/**
 * Globale Fotodokumentations-Seite. Projektauswahl oben, dann
 * normale Foto-Galerie unten (identisch zum Projekt-Detail-Panel).
 */
export function PhotoDocumentationPage() {
  const projectsQ = useProjects({ is_archived: false });
  const [selectedId, setSelectedId] = usePersistedState<number | null>(
    'photodoc.lastProjectId',
    null,
  );
  const [search, setSearch] = useState('');

  const projects = (projectsQ.data ?? []).filter((p) =>
    !search.trim()
      ? true
      : `${p.order_number} ${p.title}`.toLowerCase().includes(search.trim().toLowerCase()),
  );

  const selectedProject = projects.find((p) => p.id === selectedId) ?? null;

  return (
    <>
      <header className="topbar">
        <div className="topbar-title">Fotodokumentation</div>
      </header>

      <div className="content">
        <div
          className="card"
          style={{
            padding: 16,
            marginBottom: 20,
            display: 'flex',
            gap: 12,
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          <div style={{ flex: 1, minWidth: 240 }}>
            <label className="form-label" style={{ marginBottom: 6 }}>
              Projekt auswählen
            </label>
            <select
              value={selectedId ?? ''}
              onChange={(e) => setSelectedId(e.target.value ? Number(e.target.value) : null)}
              style={{ width: '100%' }}
            >
              <option value="">— bitte wählen —</option>
              {projects.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.order_number} · {p.title}
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <label className="form-label" style={{ marginBottom: 6 }}>
              Suche
            </label>
            <input
              type="search"
              placeholder="Auftrag oder Titel filtern…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ width: '100%' }}
            />
          </div>
        </div>

        {selectedProject ? (
          <>
            <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--color-navy)' }}>
                  {selectedProject.title}
                </div>
                <div style={{ fontSize: 13, color: 'var(--color-text-soft)' }}>
                  Auftrag {selectedProject.order_number}
                </div>
              </div>
              <Link
                to={`/projects/${selectedProject.id}`}
                className="btn btn-ghost btn-sm"
                style={{ textDecoration: 'none' }}
              >
                Zum Projekt-Detail →
              </Link>
            </div>
            <PhotosPanel projectId={selectedProject.id} />
          </>
        ) : (
          <div className="empty-state" style={{ padding: 40 }}>
            <p>Bitte oben ein Projekt wählen, um seine Fotos zu sehen.</p>
          </div>
        )}
      </div>
    </>
  );
}
